module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921054151_T.74b2040e.jpg";